import React from 'react';

const Navbar = () => {
  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-primary">
              spikedqcumber
            </span>
          </div>
          <div className="hidden md:flex space-x-8">
            <a href="/" className="text-gray-700 hover:text-primary">
              Home
            </a>
            <a href="#about" className="text-gray-700 hover:text-primary">
              About
            </a>
            <a href="#services" className="text-gray-700 hover:text-primary">
              Services
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
